/* Pretty Ballerinas - scratch card with prize, copy-code and celebration */
(function () {
  'use strict';
  var cfg = window.pbScratch;
  if (!cfg) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var KEY = 'pb_scratch_result_v1';

  function parsePrizes(text) {
    return String(text || '').split('\n').map(function (line) {
      var parts = line.split('|').map(function (s) { return s.trim(); });
      if (parts.length < 3 || !parts[0]) return null;
      var w = parseFloat(parts[2]);
      return { name: parts[0], code: parts[1], weight: isNaN(w) ? 0 : w };
    }).filter(Boolean);
  }

  function pick(prizes) {
    var total = 0, r = Math.random() * 100, acc = 0;
    prizes.forEach(function (p) { total += p.weight; });
    for (var i = 0; i < prizes.length; i++) {
      acc += prizes[i].weight;
      if (r < acc) return prizes[i];
    }
    return null; // no prize (chance left over)
  }

  function saved() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function save(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }

  function build() {
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main || document.querySelector('.pbs-card')) return;
    var prizes = parsePrizes(cfg.prizes);

    var wrap = document.createElement('section');
    wrap.className = 'pbs-card page-width';
    wrap.setAttribute('aria-label', cfg.title || 'Scratch card');
    wrap.innerHTML =
      '<div class="pbs-card__card">' +
        '<div class="pbs-card__reveal">' +
          '<p class="pbs-card__eyebrow"></p>' +
          '<h2 class="pbs-card__title"></h2>' +
          '<div class="pbs-card__code" hidden>' +
            '<span class="pbs-card__codevalue"></span>' +
            '<button type="button" class="pbs-card__copy"></button>' +
          '</div>' +
          '<a class="pbs-card__cta" href="#"></a>' +
          '<span class="pbs-card__sr" role="status" aria-live="polite"></span>' +
        '</div>' +
        '<canvas class="pbs-card__canvas" aria-hidden="true"></canvas>' +
        '<span class="pbs-card__burst" aria-hidden="true"></span>' +
      '</div>';

    var eyebrow = wrap.querySelector('.pbs-card__eyebrow');
    var title = wrap.querySelector('.pbs-card__title');
    var codeBox = wrap.querySelector('.pbs-card__code');
    var codeVal = wrap.querySelector('.pbs-card__codevalue');
    var copyBtn = wrap.querySelector('.pbs-card__copy');
    var cta = wrap.querySelector('.pbs-card__cta');
    var sr = wrap.querySelector('.pbs-card__sr');
    var card = wrap.querySelector('.pbs-card__card');
    var canvas = wrap.querySelector('.pbs-card__canvas');

    eyebrow.textContent = cfg.hint || 'Scratch to reveal';
    copyBtn.textContent = cfg.copyLabel || 'Copy code';
    cta.textContent = cfg.cta || 'Shop the gifts';

    function showResult(prize, animate) {
      var link = cfg.link || '/collections/new-arrivals';
      if (prize && prize.code) {
        title.textContent = prize.name;
        codeVal.textContent = prize.code;
        codeBox.hidden = false;
        cta.textContent = cfg.shopCodeLabel || 'Shop with this code';
        cta.href = link + (link.indexOf('?') > -1 ? '&' : '?') + 'discount=' + encodeURIComponent(prize.code);
      } else {
        title.textContent = cfg.thanks || 'Thank you for scratching!';
        codeBox.hidden = true;
        cta.href = link;
      }
      if (animate) celebrate(!!(prize && prize.code));
    }

    copyBtn.addEventListener('click', function () {
      var code = codeVal.textContent;
      var done = function () {
        copyBtn.textContent = cfg.copiedLabel || 'Copied!';
        sr.textContent = 'Code copied';
        setTimeout(function () { copyBtn.textContent = cfg.copyLabel || 'Copy code'; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(function () { fallbackCopy(code); done(); });
      } else { fallbackCopy(code); done(); }
    });

    function fallbackCopy(text) {
      var t = document.createElement('textarea');
      t.value = text; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(t);
    }

    main.insertBefore(wrap, main.firstChild);

    var prior = saved();
    var result = prior;
    if (!result) {
      // prize is decided now, but only shown after scratching
      var won = pick(prizes);
      result = { prize: won ? { name: won.name, code: won.code } : null };
      save(result);
    }
    var previously = !!prior;
    // already scratched in this browser: show the same result straight away
    if (previously) {
      canvas.style.display = 'none';
      card.classList.add('is-revealed');
      showResult(result.prize, false);
    } else {
      showResult(result.prize, false);
      setup(canvas, card, function () { showResult(result.prize, true); });
    }
  }

  function setup(canvas, card, onReveal) {
    var ctx = canvas.getContext('2d');
    var done = false, drawing = false, scratched = 0;

    function size() {
      var r = card.getBoundingClientRect();
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(r.width * dpr);
      canvas.height = Math.round(r.height * dpr);
      canvas.style.width = r.width + 'px';
      canvas.style.height = r.height + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      if (!done) paint();
    }

    function paint() {
      var w = canvas.clientWidth, h = canvas.clientHeight;
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, '#1c1c1c'); g.addColorStop(0.55, '#3a2a30'); g.addColorStop(1, '#6e1f2f');
      ctx.globalCompositeOperation = 'source-over';
      ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
      ctx.fillStyle = 'rgba(250,247,244,.08)';
      for (var i = 0; i < 60; i++) { ctx.beginPath(); ctx.arc((i * 97) % w, (i * 53) % h, 18 + (i % 5) * 6, 0, Math.PI * 2); ctx.fill(); }
      ctx.fillStyle = '#faf7f4'; ctx.font = '600 16px Arial, sans-serif';
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.fillText('S C R A T C H   H E R E', w / 2, h / 2);
    }

    function pos(e) {
      var r = canvas.getBoundingClientRect(); var p = e.touches ? e.touches[0] : e;
      return { x: p.clientX - r.left, y: p.clientY - r.top };
    }

    function scratch(e) {
      if (!drawing || done) return;
      var p = pos(e);
      ctx.globalCompositeOperation = 'destination-out';
      ctx.beginPath(); ctx.arc(p.x, p.y, 22, 0, Math.PI * 2); ctx.fill();
      scratched++;
      if (scratched % 12 === 0) checkDone();
    }

    function checkDone() {
      try {
        var d = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        var clear = 0, total = 0;
        for (var i = 3; i < d.length; i += 64) { total++; if (d[i] < 32) clear++; }
        if (clear / total > 0.55) reveal();
      } catch (err) {}
    }

    function reveal() {
      if (done) return;
      done = true;
      card.classList.add('is-revealed');
      canvas.style.transition = reduce ? 'none' : 'opacity .6s ease';
      canvas.style.opacity = '0';
      setTimeout(function () { canvas.style.display = 'none'; }, reduce ? 0 : 650);
      onReveal();
    }

    canvas.addEventListener('pointerdown', function (e) { drawing = true; scratch(e); });
    canvas.addEventListener('pointermove', scratch);
    window.addEventListener('pointerup', function () { drawing = false; });
    canvas.addEventListener('touchstart', function (e) { drawing = true; scratch(e); }, { passive: true });
    canvas.addEventListener('touchmove', scratch, { passive: true });
    window.addEventListener('touchend', function () { drawing = false; });
    window.addEventListener('resize', size);
    size();
  }

  function celebrate(won) {
    var card = document.querySelector('.pbs-card__card');
    if (!card) return;
    card.classList.remove('is-celebrating'); void card.offsetWidth; card.classList.add('is-celebrating');
    if (reduce) return;
    var burst = card.querySelector('.pbs-card__burst');
    var colours = ['#f2a7b8', '#fce8e4', '#c9677f', '#faf7f4', '#d4af37'];
    var n = won ? 26 : 8;
    for (var i = 0; i < n; i++) {
      var s = document.createElement('i');
      s.className = 'pbs-card__bit';
      s.style.background = colours[i % colours.length];
      s.style.left = (30 + Math.random() * 40) + '%';
      s.style.setProperty('--dx', (Math.random() * 360 - 180) + 'px');
      s.style.setProperty('--dy', (-120 - Math.random() * 160) + 'px');
      s.style.setProperty('--rot', (Math.random() * 720 - 360) + 'deg');
      s.style.animationDelay = (Math.random() * 0.15) + 's';
      burst.appendChild(s);
      setTimeout((function (el) { return function () { el.remove(); }; })(s), 1500);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();
